import { createRoute, lazyRouteComponent } from '@tanstack/react-router';

import { PID_AUTH_CALLBACK_PATH } from '../../context/TokenProvider/TokenProvider';
import { rootRoute } from '../../router/routes/rootRoute';

export const authPidCallbackRoute = createRoute({
	path: PID_AUTH_CALLBACK_PATH,
	getParentRoute: () => rootRoute,
	component: lazyRouteComponent(
		() => import('./PidCallbackPage'),
		'PidCallbackPage',
	),
	staticData: {
		disableAuthGuard: true,
	},
});
